/* eslint-disable react/prop-types */
import React from 'react';
import styled from '@emotion/styled';
import { H5 } from '@contently/toolkit';
import { removeCentsAddCommas } from '../value/utils';

const ToolTipText = styled(H5)`
  color: ${props => props.color};
`;

const RegularCell = ({ data, trafficValAvg }) => {
  const { value } = data.cell;
  const pubComparisonColor = value >= trafficValAvg ? 'green' : 'red';

  return <ToolTipText color={pubComparisonColor}>${removeCentsAddCommas(value)}</ToolTipText>;
};

export default RegularCell;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/TrafficValueCell.jsx